import { ErrorHandler, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly router = inject(Router);

  handleError(error: Error): void {
    console.error('Global error caught:', error);

    // Log to external error tracking service if configured
    this.logErrorToService(error);

    // Navigate to error page
    this.router.navigate(['/error'], {
      queryParams: { message: this.getErrorMessage(error) },
    });
  }

  private getErrorMessage(error: Error): string {
    if (error?.message) {
      return error.message;
    }
    return 'An unexpected error occurred';
  }

  private logErrorToService(error: Error): void {
    // TODO: Integrate with error tracking service (e.g., Sentry, LogRocket)
    // Example: Sentry.captureException(error);
  }
}
